import { render } from "./TrackShipment.vue?vue&type=template&id=9644601e&scoped=true"
import script from "./TrackShipment.vue?vue&type=script&lang=js"
export * from "./TrackShipment.vue?vue&type=script&lang=js"

import "./TrackShipment.vue?vue&type=style&index=0&id=9644601e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9644601e"]])

export default __exports__